// The two leagues the snapshot site knows (its leagueTables: FAWSL = 37, NWSL = 49), by DB id,
// in the snapshot's own order. Live mode keeps their snapshot labels and puts them first in
// the pickers (live/league.ts leagueChoices), as it always has — but live mode no longer
// downloads the snapshot (step 1, the no-snapshot build), so the map is written out here.
// It matches data/league.ts getLeagueIdNames(snapshot); the snapshot is fixed, so it can't drift.

import type { CompetitionId } from "../data/league.js";

export const KNOWN_LEAGUE_NAMES: ReadonlyMap<CompetitionId, string> = new Map([
  [37, "FAWSL"],
  [49, "NWSL"],
]);
